<template>
  <qx-card title="列表">
    <EditDialog ref="editDialog" @sub="getData" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='cmSalaryInfoNewBO.ajax?cmd=getSalaryOrders'
          :params="fullSearchData"
          bizName="司机工资详情导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            >
            <template slot="header">
                <span v-if="item.insertParent">
                  {{ item.label }}
                 <el-popover placement="top" width="300" trigger="hover" popper-class="popoverBackB">
                   <div>若司机超出“出车打款金额”，则应将该超出部分附加到本订单工资中；</div>
                   <div>若司机剩余“出车打款金额”，则应将该剩余部分从该订单的基本工资中扣除；</div>
                  <i class="el-icon-question warning" slot="reference"></i>
                </el-popover>
                </span>
            </template>
              <section  slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'orderId'">
                  <span :class="scope.row.paymentWay!==2 && scope.row.isVerity===1?'primary cur':''" @click="toOrderDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                </section>
                <!-- 订单号码 end -->
                <section v-else-if="scope.column.property === 'carDriverName'" @click="toDriverDetail(scope.row)">
                  <span class="primary cur">{{scope.row[scope.column.property]}}</span>
                </section>
                <!-- 订单扣款以负数展示 -->
                <section v-else-if="scope.column.property === 'orderDeductionDouble'">
                  <span>{{ formatOrderDeduction(scope.row[scope.column.property]) }}</span>
                </section>
                <!-- 实发比例 -->
                <section v-else-if="scope.column.property === 'actualProportionStr'">
                  <span >{{scope.row[scope.column.property] +'%' }}</span>
                </section>
                <!-- 实发比例 end -->
                <section v-else>{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" fixed="right" width="120">
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="6000914">
                  <span class="primary cur" @click="showEditDialiog(scope.row)">修改</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import EditDialog from './editDialog';
import ExportBtn from 'components/exportBtn';
import {
  driverSalaryDetailList, driverSalaryListName,
} from 'api/getPay';
import {mapState} from 'vuex';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    EditDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverSalaryDetailList,
    formatOrderDeduction (value) {
      const amount = Number(value);
      if (!Number.isFinite(amount) || amount === 0) {
        return '0.00';
      }
      return `-${Math.abs(amount).toFixed(2)}`;
    },
    toOrderDetail (item, defaultActive = '', defaultChildActive = 'carrier', isVerity) {
      console.log(item.orderId);
      if (item.isVerity && item.paymentWay !== 2) {
        this.jump({
          label: `订单详情-${item.orderId}`,
          url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}&defaultActive=${defaultActive}&defaultChildActive=${defaultChildActive}&isVerity=1`,
          full: true,
        });
      }
    },
    showEditDialiog (item) { // 修改
      this.$refs.editDialog.show(item);
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  created () {
    if (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) { // 福鹏要展示的字段
      this.tableData.title = [
        { prop: 'orderId', label: '订单号' },
        { prop: 'companyName', label: '客户全称' },
        { prop: 'dependTimeStr', label: '发车时间' },
        { prop: 'orderLine', label: '线路' },
        { prop: 'plateNumber', label: '车牌号' },
        { prop: 'trailerPlate', label: '挂车车牌' },
        { prop: 'c', label: '状态' },
        { prop: 'carDriverMan', label: '司机姓名' },
        { prop: 'carPrepayMoneyDouble', label: '出车打款金额' },
        { prop: 'moneyValuePayDouble', label: '出车款剩余金额',
          // insertParent: 'moneyValuePayDouble'
        },
        { prop: 'oilSavingAwardsDouble', label: '节油奖' },
        { prop: 'orderSubsidyDouble', label: '订单补贴' },
        { prop: 'orderBaseSalaryDouble', label: '司机基本服务费' },
        { prop: 'thisSalaryDouble', label: '本趟服务费' },
        { prop: 'subsidyRemark', label: '补贴备注' },
        { prop: 'mieageNumberStr', label: '公里数',
        },
      ];
    } else {
      this.tableData.title = [ // 系统最初展示的字段
        {prop: 'orderId', label: '订单号'},
        {prop: 'companyName', label: '客户全称'},
        {prop: 'dependTimeStr', label: '发车时间'},
        {prop: 'orderLine', label: '线路'},
        {prop: 'plateNumber', label: '车牌号'},
        {prop: 'trailerPlate', label: '挂车车牌'},
        {prop: 'c', label: '状态'},
        {prop: 'carDriverMan', label: '司机姓名'},
        {prop: 'carPrepayMoneyDouble', label: '出车打款金额'},
        {
          prop: 'moneyValuePayDouble', label: '出车款剩余金额',
          // insertParent: 'moneyValuePayDouble'
        },
        {prop: 'oilSavingAwardsDouble', label: '节油奖'},
        {prop: 'orderSubsidyDouble', label: '订单补贴'},
        {prop: 'orderBaseSalaryDouble', label: '司机基本工资'},
        {prop: 'thisSalaryDouble', label: '本趟工资'},
        {prop: 'subsidyRemark', label: '补贴备注'},
        {
          prop: 'mieageNumberStr', label: '公里数',
        },
      ];
    }
  },
  async mounted () {
    const res = await driverSalaryListName({
      settleMonth: this.$route.query.settleMonth,
      channelType: 'WEB-details',
    });
    if (!res.failed) {
      let data = [];
      res.items.map((item) => {
        item.show = true;
        data.push(item);
      });
      this.tableData.title = data;
    }
  },
};
</script>

<style lang="scss" scoped>
.introBtn{
  margin-left: 16px;
}
.control {
  span {
    margin-right: 8px;
  }
}
</style>

<style lang="scss">
.el-popover.popoverBackB{
  background: #FFFF00 !important;
}
</style>
